import { useEffect, useState } from 'react'
import ProjectHubDashboard from '@/components/hub/ProjectHubDashboard'
import { fetchHubProjects } from '@/services/hubProjects'

export default function HubDashboardPage() {
  const [projects, setProjects] = useState([])
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const { data, error } = await fetchHubProjects()
      if (cancelled) return
      if (error) {
        setErrorMessage(error.message || String(error))
        setProjects([])
        return
      }
      setErrorMessage('')
      setProjects(data || [])
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-lg font-semibold tracking-tight">Projects</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Status, priority, and stack at a glance. Supabase is the source of truth; manifests sync to{' '}
          <code className="font-mono text-xs">/projects</code>.
        </p>
      </div>
      <ProjectHubDashboard projects={projects} errorMessage={errorMessage} />
    </div>
  )
}
